"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _underscore = require("underscore");
var _sources = require("@studio/sources");
var _program = require("@studio/program");
var _constants = require("@studio/constants");
var _utils = require("../../utils");
var _setSceneLayout = _interopRequireDefault(require("../program/setSceneLayout"));
var _setMultipleDesiredAttendeeMuteStatuses = _interopRequireDefault(require("../attendee/setMultipleDesiredAttendeeMuteStatuses"));
var _clearStagedSources = _interopRequireDefault(require("./clearStagedSources"));
var _setMultipleDesiredAttendeeCameraStatuses = _interopRequireDefault(require("../attendee/setMultipleDesiredAttendeeCameraStatuses"));
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
var _logger = require("@studio/logger");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function takeStagedSourcesLive(updateSource, setProgram) {
  return function (dispatch, getState) {
    var _meetingResponse$Meet;
    var _getState = getState(),
      sceneLayout = _getState.sceneLayout,
      sceneLayers = _getState.sceneLayers,
      banners = _getState.banners,
      attendeeMuteStatus = _getState.attendeeMuteStatus,
      attendeeCameraStatus = _getState.attendeeCameraStatus,
      broadcastSources = _getState.broadcastSources.sources,
      _getState$stagedSourc = _getState.stagedSources,
      stagedSources = _getState$stagedSourc.sources,
      stagedLayout = _getState$stagedSourc.sceneLayout,
      featuredPresenterId = _getState.featuredPresenter,
      _getState$broadcastSe = _getState.broadcastSettings,
      dragAndDrop = _getState$broadcastSe.dragAndDrop,
      autoMutePresenters = _getState$broadcastSe.autoMutePresenters,
      program = _getState.program,
      serverTimeDelta = _getState.serverTimeDelta,
      meetingResponse = _getState.meeting.meetingResponse,
      brandingSettings = _getState.brandingSettings;
    var combinedLayers = [].concat(_toConsumableArray(sceneLayers), _toConsumableArray(banners));
    var layout = stagedLayout || sceneLayout;
    var stagedSourceIds = Object.keys(stagedSources).filter(function (sourceId) {
      return stagedSources[sourceId];
    });
    var sourcesToUpdate = [];
    var allStagedSources = broadcastSources.filter(function (bs) {
      return _toConsumableArray(stagedSourceIds).includes(bs._id);
    }).map(function (source) {
      return _objectSpread(_objectSpread({}, source), {}, {
        featured: source._id === featuredPresenterId,
        hidden: false
      });
    }).map(function (source) {
      if ((0, _utils.isMediaSource)(source.type)) {
        var wasInProgram = program.layers && program.layers.filter(function (ls) {
          return ls.source._id === source._id;
        }).length > 0;
        // if this was not in the program we set seek to 0 and startedOn
        if (!wasInProgram) {
          source.value.seek = 0;
          source.value.isPlaying = true;
          source.value.startedOn = (0, _utils.getStartedOn)(true, serverTimeDelta);
        }
        // if it is an audio source we need set hidden to false so that the
        // scene builder does not exclude it
        if ((0, _sources.isAudioSource)(source)) source.hidden = false;
        sourcesToUpdate.push(source);
        return source;
      }
      return source;
    });
    var _partition = (0, _underscore.partition)(allStagedSources, _sources.isCameraPresenter),
      _partition2 = _slicedToArray(_partition, 2),
      allStagedCamSources = _partition2[0],
      restStagedSources = _partition2[1];
    // slice only 10 cam sources
    var stagedCamSources = allStagedCamSources.slice(0, Math.min(allStagedCamSources.length, _constants.CAMERA_PRESENTER_LIMIT));
    var sources = [].concat(_toConsumableArray(stagedCamSources), _toConsumableArray(restStagedSources));
    var meetingId = meetingResponse === null || meetingResponse === void 0 ? void 0 : (_meetingResponse$Meet = meetingResponse.Meeting) === null || _meetingResponse$Meet === void 0 ? void 0 : _meetingResponse$Meet.MeetingId;
    var camSourcesInProgram = (0, _sources.getCameraPresenterSources)(program.layers);
    var stagedCamSourcesIds = stagedCamSources.map(function (source) {
      return source._id;
    });
    Object.entries(camSourcesInProgram).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        srcID = _ref2[0],
        src = _ref2[1];
      if (!stagedCamSourcesIds.includes(srcID)) {
        var logPayload = {
          'studio.actionName': 'Take Staged Sources Live',
          'studio.attendeeTileStatus': 'OFF-STAGE',
          'studio.tileAttendeeId': src.value,
          title: "ProgramUpdate: Attendee ".concat(src.value, " in meeting ").concat(meetingId, " is removed from the stage")
        };
        (0, _logger.sendToDatadog)('program-update', logPayload, logPayload.title, false);
      }
    });
    stagedCamSources.filter(function (source) {
      return !camSourcesInProgram[source._id];
    }).forEach(function (src) {
      var logPayload = {
        'studio.actionName': 'Take Staged Sources Live',
        'studio.attendeeTileStatus': 'ON-STAGE',
        'studio.tileAttendeeId': src.value,
        title: "ProgramUpdate: Attendee ".concat(src.value, " in meeting ").concat(meetingId, " is added to the stage")
      };
      (0, _logger.sendToDatadog)('program-update', logPayload, logPayload.title, false);
    });
    (0, _reactRedux.batch)(function () {
      /**
       * Set the desired attendee camera status to on if it is off.
       */
      var updatedCameraStatuses = {};
      sources.forEach(function (source) {
        var sourceValue = (0, _sources.getSourceValue)(source);
        var isAttendeeCameraOn = !!attendeeCameraStatus[sourceValue];
        if (!isAttendeeCameraOn && !source.cameraUnavailable) {
          updatedCameraStatuses[sourceValue] = true;
        }
      });
      if (!(0, _underscore.isEmpty)(updatedCameraStatuses)) {
        dispatch((0, _setMultipleDesiredAttendeeCameraStatuses["default"])(updatedCameraStatuses));
      }

      /** Audio/Video sources to make update */
      sourcesToUpdate.forEach(function (source) {
        dispatch(updateSource(source._id, {
          value: source.value,
          hidden: source.hidden
        }));
      });
    });
    var sceneSources = dragAndDrop ? (0, _utils.orderSources)(sources) : sources;

    /**
     * When taking sources live we attach audioPresenters for all unmuted camera sources.
     * We use this next unmuted attendees state only when autoMutePresenters setting is enabled otherwise maintain status quo
     */
    var nextMuteStatuses = autoMutePresenters ? (0, _utils.getAttendeesNextMuteStatuses)(sources, broadcastSources) : attendeeMuteStatus;
    var withAudioPresenterSources = (0, _sources.attachAudioPresenterSources)(sceneSources, nextMuteStatuses);
    var scene = (0, _program.sceneBuilder)(layout, withAudioPresenterSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);

    /** Update all staged attendees mute status */
    autoMutePresenters && dispatch((0, _setMultipleDesiredAttendeeMuteStatuses["default"])(nextMuteStatuses));
    dispatch(setProgram(scene));
    (0, _sendToDatadogWithIds.logProgramChange)(getState, 'takeStagedSourcesLive action');
    if (!(0, _underscore.isEqual)(sceneLayout, stagedLayout)) {
      dispatch((0, _setSceneLayout["default"])(layout));
    }

    // Finally clear all selections
    dispatch((0, _clearStagedSources["default"])());
  };
}
var _default = exports["default"] = takeStagedSourcesLive;